import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";

import { Box, FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";

import theme from "@/foundation/Theme";

import {
  CardLink,
  BottomTextContainer,
  Chip,
  ChipText,
  CookingTimeAndIngredientsContainer,
  RecipeItemContainer,
  RecipeTitle,
  TopContainer,
  ImageWrapper,
} from "./style";

const RecipeCard = ({ data }) => {
  const router = useRouter();

  const {
    coverImage,
    title,
    cookingTime,
    ingredientsCount,
    rating,
    isFavorite,
    slug,
    shareUrl,
  } = data || {};

  const FullStar = () => (
    <StyledSvgSprite
      icon="icon-star-fill"
      fill={theme.colorsV2.warning.shade_400}
      stroke={theme.colorsV2.warning.shade_400}
      height="16px"
      width="16px"
    />
  );

  return (
    <CardLink
      onClick={() => router.push(slug ? `/recipes/${slug}/` : shareUrl)}
    >
      <RecipeItemContainer>
        <ImageWrapper>
          <Image src={coverImage} fill alt={title} />
        </ImageWrapper>
        <TopContainer>
          <Chip>
            <FullStar />
            <ChipText variant="label1" fontFamily="var(--man-700)">
              {rating}
            </ChipText>
          </Chip>

          <FlexDiv
            height="24px"
            width="24px"
            borderRadius="50%"
            justifyContent="center"
            alignItems="center"
            bg={isFavorite ? "#F04438" : "rgba(255,255,255,0.4)"}
          >
            <StyledSvgSprite
              icon="icon-ixon-heart"
              fill={isFavorite ? "#ffffff" : "#98A2B3"}
              height="11px"
              width="12.5px"
            />
          </FlexDiv>
        </TopContainer>
        <BottomTextContainer>
          <h2 style={{ margin: 0 }}>
            <Link
              href={slug ? `/recipes/${slug}/` : shareUrl}
              prefetch={false}
              style={{ textDecoration: "none" }}
            >
              <RecipeTitle variant="span" fontFamily="var(--man-700)">
                {title}
              </RecipeTitle>
            </Link>
          </h2>
          <CookingTimeAndIngredientsContainer>
            <Chip>
              <ChipText
                variant="label3"
                fontFamily="var(--man-700)"
              >{`${cookingTime} minutes`}</ChipText>
            </Chip>
            <Chip>
              <ChipText
                variant="label3"
                fontFamily="var(--man-700)"
              >{`${ingredientsCount} Ingredients`}</ChipText>
            </Chip>
          </CookingTimeAndIngredientsContainer>
        </BottomTextContainer>
      </RecipeItemContainer>
    </CardLink>
  );
};

export default RecipeCard;
